import axios from "axios";

const API_URL = process.env.VUE_APP_API_BASE_URL;
class NotificationService {
  static async getAllNotifications() {
    const response = await axios.get(`${API_URL}/notifications/me`);
    return response.data?.data || [];
  }
  static async getAllNotificationsWithStaff() {
    return this.getAllNotifications();
  }
}
export default NotificationService;
